(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', function(event) {
  const form = event.target.closest(
    '.tv-catalog .collection-controls'
  );

  if (!form) return;

  if (event.target.matches('select,input[type="checkbox"]')) {
    form.requestSubmit();
  }
});

document.addEventListener('click', function(event) {
  const summary = event.target.closest(
    '.tv-catalog .filter summary'
  );

  if (!summary) return;

  summary.closest('.collection-controls')
    .querySelectorAll('details[open]')
    .forEach(function(details) {
      if (details !== summary.parentElement) {
        details.removeAttribute('open');
      }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["talvireo-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('talvireo-product')) {
  customElements.define('talvireo-product', class extends HTMLElement {
    connectedCallback() {
      if(this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.form = this.querySelector('.tvp-form');
      this.variant = this.querySelector('[data-variant]');
      this.quantity = this.querySelector('input[data-quantity]');
      if(!this.form || !this.variant || !this.quantity) return;
      this.money = value => new Intl.NumberFormat(this.dataset.locale || 'nl-BE', {style:'currency',currency:this.dataset.currency || 'EUR'}).format(value / 100);
      this.slides = [...this.querySelectorAll('[data-media-id]')];
      this.activeSlide = Math.max(0, this.slides.findIndex(slide => !slide.hidden));
      this.querySelector('[data-addons]')?.removeAttribute('hidden');
      this.querySelectorAll('[data-thumb]').forEach(button => button.addEventListener('click', () => this.showMedia(button.dataset.thumb), {signal}));
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.showSlide(this.activeSlide - 1), {signal});
      this.querySelector('[data-next]')?.addEventListener('click', () => this.showSlide(this.activeSlide + 1), {signal});
      this.querySelector('[data-gallery]')?.addEventListener('keydown', event => {if(event.target !== event.currentTarget) return;if(event.key === 'ArrowRight') {event.preventDefault();this.showSlide(this.activeSlide + 1);}if(event.key === 'ArrowLeft') {event.preventDefault();this.showSlide(this.activeSlide - 1);}}, {signal});
      this.initOptionPicker(signal);
      this.variant.addEventListener('change', () => {this.updateVariant();const url = new URL(window.location.href);url.searchParams.set('variant', this.variant.value);history.replaceState({}, '', url);}, {signal});
      this.querySelectorAll('[data-offer]').forEach(input => input.addEventListener('change', () => {this.quantity.value = input.value;this.updateTotal();}, {signal}));
      this.quantity.addEventListener('input', () => this.updateTotal(), {signal});
      this.quantity.addEventListener('change', () => {this.normalizeQuantity();this.updateTotal();}, {signal});
      this.querySelector('[data-minus]')?.addEventListener('click', () => this.changeQuantity(-1), {signal});
      this.querySelector('[data-plus]')?.addEventListener('click', () => this.changeQuantity(1), {signal});
      this.querySelectorAll('[data-set]').forEach(input => input.addEventListener('change', () => this.updateTotal(), {signal}));
      this.querySelectorAll('[data-set-variant]').forEach(select => select.addEventListener('change', () => {
        this.querySelectorAll('[data-set-variant]').forEach(other => {if(other.dataset.product === select.dataset.product) other.value = select.value;});
        this.updateTotal();
      }, {signal}));
      this.querySelectorAll('[data-addon]').forEach(input => input.addEventListener('change', () => this.updateTotal(), {signal}));

      this.querySelector('[data-sticky-add]')?.addEventListener('click', () => {this.querySelector('[data-sets]')?.scrollIntoView({block:'center',behavior:'smooth'});this.querySelector('[data-set]:checked')?.focus({preventScroll:true});}, {signal});
      this.deadline = this.querySelector('[data-deadline]');
      this.deadlineTime = this.deadline ? Date.parse(this.deadline.dataset.deadline) : NaN;
      this.updateDeadline();
      if(Number.isFinite(this.deadlineTime)) this.deadlineInterval = setInterval(() => {this.updateDeadline();this.updateVariant();}, 60000);
      this.updateVariant();
      this.showSlide(this.activeSlide);
      const sticky = this.querySelector('[data-sticky]');
      if(sticky) {
        const updateSticky = () => {const show = this.querySelector('[data-add]').getBoundingClientRect().bottom <= 0;sticky.hidden = !show;this.classList.toggle('has-sticky', show);};
        let scheduled = false;
        const scheduleSticky = () => {if(scheduled) return;scheduled = true;requestAnimationFrame(() => {scheduled = false;if(this.isConnected) updateSticky();});};
        window.addEventListener('scroll', scheduleSticky, {passive:true,signal});
        window.addEventListener('resize', scheduleSticky, {passive:true,signal});
        updateSticky();
      }
    }
    initOptionPicker(signal) {
      this.picker = this.querySelector('[data-option-picker]');
      if(!this.picker) return;
      this.optionVariants = [...this.variant.options].map(option => ({option, values:JSON.parse(option.dataset.options)}));
      this.querySelectorAll('[data-variant-fallback]').forEach(element => element.hidden = true);
      this.picker.hidden = false;
      this.picker.querySelectorAll('[data-option-value]').forEach(button => button.addEventListener('click', () => {
        const index = Number(button.closest('[data-option-index]').dataset.optionIndex);
        const values = JSON.parse(this.variant.selectedOptions[0].dataset.options);
        values[index] = button.dataset.optionValue;
        const exact = this.optionVariants.find(item => item.values.every((value, position) => value === values[position]));
        const candidates = this.optionVariants.filter(item => item.values[index] === values[index]);
        const match = exact?.option.dataset.available === 'true' ? exact : candidates.find(item => item.option.dataset.available === 'true') || exact || candidates[0];
        if(!match) return;
        this.variant.value = match.option.value;
        this.variant.dispatchEvent(new Event('change', {bubbles:true}));
      }, {signal}));
    }
    syncOptionPicker() {
      if(!this.picker) return;
      const values = JSON.parse(this.variant.selectedOptions[0].dataset.options);
      this.picker.querySelectorAll('[data-option-index]').forEach(group => {
        const index = Number(group.dataset.optionIndex);
        group.querySelector('[data-selected-option]').textContent = values[index];
        group.querySelectorAll('[data-option-value]').forEach(button => {
          button.setAttribute('aria-pressed', String(values[index] === button.dataset.optionValue));
          button.disabled = !this.optionVariants.some(item => item.values[index] === button.dataset.optionValue && item.option.dataset.available === 'true' && item.values.every((value, position) => position >= index || value === values[position]));
        });
      });
      const label = this.dataset.optionSummaryLabel || '__variant__';
      this.picker.querySelector('[data-option-summary-text]').textContent = label.replace('__variant__', this.variant.selectedOptions[0].textContent.trim());
    }
    disconnectedCallback() {this.abort?.abort();clearInterval(this.deadlineInterval);this.ready = false;}
    showMedia(id) {const index = this.slides.findIndex(slide => slide.dataset.mediaId === id);if(index >= 0) this.showSlide(index);}
    showSlide(index) {
      if(!this.slides.length) return;
      this.activeSlide = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {slide.hidden = i !== this.activeSlide;if(slide.hidden) slide.querySelectorAll('video').forEach(video => video.pause());});
      const selected = this.slides[this.activeSlide].dataset.mediaId;
      this.querySelectorAll('[data-thumb]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.thumb === selected)));
      const count = this.querySelector('[data-media-count]');if(count) count.textContent = `${this.activeSlide + 1} / ${this.slides.length}`;
    }
    updateVariant() {
      const option = this.variant.selectedOptions[0];if(!option) return;
      this.current = option;
      this.syncOptionPicker();
      this.querySelector('[data-price]').textContent = option.dataset.formattedPrice;
      this.querySelector('[data-sticky-price]')?.replaceChildren(document.createTextNode(option.dataset.formattedPrice));
      const compare = this.querySelector('[data-compare]');const oldPrice = Number(option.dataset.compare);const price = Number(option.dataset.price);
      compare.textContent = option.dataset.formattedCompare;compare.hidden = !(oldPrice > price);
      const saving = this.querySelector('[data-saving]');saving.hidden = !(oldPrice > price);
      if(oldPrice > price) saving.textContent = `${Math.round((oldPrice - price) / oldPrice * 100)}% ${this.dataset.savingLabel || ''}`;
      const min = Number(option.dataset.min) || 1, step = Number(option.dataset.step) || 1, max = Number(option.dataset.max) || Infinity;
      this.quantity.min = String(min);this.quantity.step = String(step);if(Number.isFinite(max)) this.quantity.max = String(max);else this.quantity.removeAttribute('max');
      this.normalizeQuantity();
      const inventoryMax = option.dataset.tracked === 'true' ? Math.max(0, Number(option.dataset.inventory)) : Infinity;
      const effectiveMax = Math.min(max, inventoryMax);
      if(Number.isFinite(effectiveMax)) this.quantity.max = String(effectiveMax);
      this.normalizeQuantity();
      this.querySelectorAll('[data-offer]').forEach(input => {
        const qty = Number(input.value);
        const expired = input.dataset.mode !== 'none' && this.offerExpired;
        input.closest('.tvp-offer').hidden = expired;
        input.disabled = expired || option.dataset.available !== 'true' || qty < min || qty > effectiveMax || qty % step !== 0;
        const base = price * qty, total = this.bundlePrice(input, price);
        const card = input.closest('.tvp-offer');
        card.querySelector('[data-offer-price]').textContent = this.money(total);
        const comparison = card.querySelector('[data-offer-compare]');comparison.hidden = !(total < base);comparison.textContent = this.money(base);
        const discount = card.querySelector('[data-offer-saving]');discount.hidden = !(total < base);discount.textContent = `${this.dataset.bundleSavingLabel} ${this.money(base - total)}`;
      });
      this.setBusy(false);
      if(option.dataset.media) this.showMedia(option.dataset.media);
      const stock = this.querySelector('[data-stock]');
      if(stock) {const number = Number(option.dataset.inventory);stock.hidden = !(option.dataset.available === 'true' && option.dataset.tracked === 'true' && number > 0 && number <= Number(stock.dataset.threshold));stock.textContent = this.dataset.stockLimitedLabel + ' · ' + (stock.dataset.label || '').replace('{aantal}', String(number));}
       const urgency = this.querySelector('.tvp-urgency');
       const urgencyMessage = urgency?.querySelector('[data-urgency-message]');
       if (urgencyMessage) {
         const count = Number(option.dataset.inventory);
         const threshold = Number(urgency.dataset.urgencyThreshold) || 15;
         const manual = Number(urgency.dataset.urgencyManual);
         const mode = urgency.dataset.urgencyMode;
         const tracked = option.dataset.tracked === 'true';
         const available = option.dataset.available === 'true';
         let message = urgency.dataset.urgencyAvailable || 'Beschikbaar om te bestellen';
         if (!available) message = urgency.dataset.urgencyUnavailable || 'Momenteel niet beschikbaar';
         else if (mode === 'manual' && manual > 0) message = (urgency.dataset.urgencyLow || 'Nog maar {aantal} stuks beschikbaar!').replace('{aantal}', String(manual));
         else if (mode === 'automatic' && tracked && count > 0 && count <= threshold) message = (urgency.dataset.urgencyLow || 'Nog maar {aantal} stuks beschikbaar!').replace('{aantal}', String(count));
         urgencyMessage.textContent = message;
         urgency.classList.toggle('tvp-urgency--sold', !available);
       }
      this.updateTotal();
    }
    normalizeQuantity() {
      const min = Number(this.quantity.min) || 1, step = Number(this.quantity.step) || 1, max = this.quantity.hasAttribute('max') ? Number(this.quantity.max) : Infinity;
      let value = Number(this.quantity.value);if(!Number.isFinite(value)) value = min;value = Math.max(min, Math.ceil(value / step) * step);if(value > max) value = Math.floor(max / step) * step;this.quantity.value = String(Math.max(min, value));
    }
    changeQuantity(direction) {this.quantity.value = String((Number(this.quantity.value) || Number(this.quantity.min)) + direction * (Number(this.quantity.step) || 1));this.normalizeQuantity();this.updateTotal();}
    updateTotal() {
      if(!this.current) return;
      const qty = Number(this.quantity.value) || 0;
      let discountCode = '';let chosen = null;
      this.querySelectorAll('[data-offer]').forEach(input => {input.checked = !input.disabled && Number(input.value) === qty;if(input.checked) {discountCode = input.dataset.code || '';chosen = input;}});
      let total = chosen ? this.bundlePrice(chosen, Number(this.current.dataset.price)) : Number(this.current.dataset.price) * qty;
      this.querySelectorAll('[data-addon]:checked').forEach(input => {if(!input.disabled) total += Number(input.dataset.price) * Number(input.dataset.quantity);});
      this.updateSetCards();
      const additions = this.setAdditions();
      additions.forEach(item => total += item.price * item.quantity);
      if(additions.some(item => item.gift)) discountCode = [discountCode,this.querySelector('[data-sets]').dataset.giftCode].filter(Boolean).join(',');
      this.querySelector('[data-total]').textContent = this.money(total);
      this.setBusy(this.busy || false);
      this.querySelector('[data-sticky-price]')?.replaceChildren(document.createTextNode(this.money(total)));
      this.discountCode = discountCode;
      this.redirectUrl = discountCode ? `${this.dataset.rootUrl}discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(this.dataset.cartUrl)}` : this.dataset.cartUrl;
      this.querySelector('[data-return]').value = this.redirectUrl;
    }
    setAdditions() {
      const card = this.querySelector('[data-set]:checked')?.closest('[data-set-card]');
      if(!card) return [];
      const items = [...card.querySelectorAll('[data-set-variant]')].map(select => {
        const option = select.selectedOptions[0];
        return {id:option.value, quantity:Number(option.dataset.quantity) || 1, price:Number(option.dataset.price), available:option.dataset.available === 'true'};
      });
      const gift = card.querySelector('[data-set-gift]');
      if(gift) items.push({id:gift.dataset.id,quantity:1,price:0,available:true,gift:true});
      return items;
    }
    updateSetCards() {
      const price = Number(this.current.dataset.price);
      const qty = Number(this.quantity.value) || 1;
      const offer = this.querySelector('[data-offer]:checked');
      const main = offer ? this.bundlePrice(offer, price) : price * qty;
      this.querySelectorAll('[data-set-card]').forEach(card => {
        let total = main;
        let comparison = Math.max(price,Number(this.current.dataset.compare)) * qty;
        let available = this.current.dataset.available === 'true';
        card.querySelectorAll('[data-set-variant]').forEach(select => {
          const option = select.selectedOptions[0];
          const count = Number(option.dataset.quantity) || 1;
          total += Number(option.dataset.price) * count;
          comparison += Math.max(Number(option.dataset.price),Number(option.dataset.compare)) * count;
          available = available && option.dataset.available === 'true';
          select.closest('[data-set-item]').querySelector('[data-set-item-price]').textContent = this.money(Number(option.dataset.price) * count);
        });
        const input = card.querySelector('[data-set]');input.disabled = !available;
        card.querySelector('[data-set-price]').textContent = this.money(total);
        const old = card.querySelector('[data-set-compare]');old.textContent = this.money(comparison);old.hidden = !(comparison > total);
        const saving = card.querySelector('[data-set-saving]');saving.textContent = `${this.dataset.bundleSavingLabel} ${this.money(comparison-total)}`;saving.hidden = !(comparison > total);
        card.querySelector('[data-set-main-price]').textContent = this.money(main);
        card.querySelector('[data-set-main-quantity]').textContent = String(qty);
        card.classList.toggle('is-selected',input.checked);
      });
      const selected = this.querySelector('[data-set]:checked');
      if(selected?.disabled) {
        selected.checked = false;
        const fallback = this.querySelector('[data-set]:not(:disabled)');
        if(fallback) {fallback.checked = true;fallback.closest('[data-set-card]').classList.add('is-selected');}
      }
    }
    bundlePrice(input, price) {
      const qty = Number(input.value);
      if(!input.dataset.code || this.offerExpired) return price * qty;
      if(input.dataset.mode === 'second_half' && qty === 2) return price * 2 - (this.dataset.halfDiscountFloor === 'true' ? Math.floor(price / 2) : Math.round(price / 2));
      if(input.dataset.mode === 'third_free' && qty === 3) return price * 2;
      return price * qty;
    }
    updateDeadline() {
      this.offerExpired = Number.isFinite(this.deadlineTime) && Date.now() >= this.deadlineTime;
      if(!this.deadline) return;
      this.deadline.hidden = !Number.isFinite(this.deadlineTime) || this.offerExpired;
      if(!this.deadline.hidden) {
        const date = new Intl.DateTimeFormat(this.dataset.locale || 'nl-BE', {day:'numeric',month:'long',hour:'2-digit',minute:'2-digit'}).format(new Date(this.deadlineTime));
        this.deadline.textContent = (this.deadline.dataset.label || '').replace('{datum}', date);
      }
    }
    setBusy(busy) {
      const available = this.current?.dataset.available === 'true' && this.setAdditions().every(item => item.available);
      this.querySelectorAll('[data-add],[data-sticky-add]').forEach(button => {button.disabled = busy || !available;button.setAttribute('aria-busy', String(busy));button.textContent = busy ? this.dataset.loadingLabel : available ? button.hasAttribute('data-sticky-add') ? this.dataset.stickyLabel : this.dataset.cartLabel : this.dataset.soldLabel;});
    }
    async submit(event) {
      event.preventDefault();if(this.busy || this.current?.dataset.available !== 'true') return;
      if(!this.form.reportValidity()) return;
      this.updateDeadline();this.updateVariant();this.normalizeQuantity();this.updateTotal();
      const additions = this.setAdditions();
      if(additions.some(item => !item.available)) return;
      const items = [{id:this.variant.value,quantity:Number(this.quantity.value)}, ...additions.map(item => ({id:item.id,quantity:item.quantity}))];
      this.querySelectorAll('[data-addon]:checked').forEach(input => {if(!input.disabled) items.push({id:input.dataset.id,quantity:Number(input.dataset.quantity)});});
      const error = this.querySelector('[data-error]');error.hidden = true;this.busy = true;this.setBusy(true);
      try {
        if(window.TalvireoCart) {await window.TalvireoCart.add(items, {discountCode:this.discountCode}); return;}
        const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if(!response.ok) throw new Error(typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : this.dataset.errorLabel);
        window.location.assign(this.redirectUrl);
      } catch(issue) {error.textContent = issue.message || this.dataset.errorLabel;error.hidden = false;error.scrollIntoView({block:'nearest'});} finally {this.busy = false;this.setBusy(false);}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["talvireo-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('talvireo-reviews')) {
    customElements.define('talvireo-reviews', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.tr-track');
        this.prev = this.querySelector('[data-tr-prev]');
        this.next = this.querySelector('[data-tr-next]');
        if (!this.track) return;
        const update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          this.prev.disabled = this.track.scrollLeft <= 2;
          this.next.disabled = this.track.scrollLeft >= max - 2;
        };
        const move = direction => {
          const card = this.track.querySelector('.tr-card');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
          const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({
            left: direction * (card.getBoundingClientRect().width + gap),
            behavior: reduceMotion ? 'auto' : 'smooth'
          });
        };
        this.prev.addEventListener('click', () => move(-1), { signal });
        this.next.addEventListener('click', () => move(1), { signal });
        this.track.addEventListener('scroll', update, { passive: true, signal });
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.tr-card');
          if (card) this.track.scrollTo({ left: card.offsetLeft, behavior: 'auto' });
        }, { signal });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(this.track);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
